const styles = (theme) => ({
  dialog: {
    backgroundColor: theme.ModalBGColor,
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  dialogTitle: {
    fontSize: theme.headerTextFontSize,
    fontWeight: '600',
    color: theme.HeaderSelectedText
  },
  dialogContent: {
    width: '100%',
    boxSizing: 'border-box',
    flex: 1,
    margin: '16px 0',
    position: 'relative',
  },
  dialogAction: {
    margin: 0,
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '10px'
  },
  button: {
    textTransform: 'none',
    '&$disabled': {
      color: theme.headerIconColor,
      borderColor: theme.headerIconColor
    }
  },
  message: {
    fontSize: '13px',
    color: theme.gridTextColor
  },
  geoCodingProgress: {
    top: '48%',
    width: '90%',
    textAlign: 'center',
    position: 'absolute',
    fontSize: theme.textFontSize,
    color: theme.TextColor,
    boxSizing: 'border-box',
    marginLeft: '5%',
    padding: 5,
    backgroundColor: theme.loadingBGColor
  },
  failMessage: {
    color: theme.ErrorMessageColor
  },
  locationUpdated: {
    color: theme.HeaderSelectedText,
    textAlign: 'center',
    minWidth: 110
  },
  locationNotUpdated: {
    color: theme.ErrorMessageColor,
    textAlign: 'center',
    minWidth: 110
  },
  disabled: {},
  addressContainer: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  searchContainer: {
    width: '33%'
  },
  lowConfidenceAddressContainer: {
    color: theme.ErrorMessageColor,
    paddingTop: 8,
    display: "flex",
    alignItems: "flex-start",
    fontSize: theme.textFontSize,
  },
  lowConfidenceAddressLabel: {
    marginLeft: 6,
  },
});

export default styles;
